document.addEventListener('DOMContentLoaded', () => {
  const inventoryData = document.getElementById('relune-product-inventory');
  if (!inventoryData) return;

  let variants;
  try {
    variants = JSON.parse(inventoryData.textContent);
  } catch (error) {
    return;
  }

  const inventoryByVariant = new Map(variants.map((variant) => [String(variant.id), variant]));

  const updateQuantityControl = () => {
    const productForm = document.querySelector('.product-details product-form-component');
    const variantInput = productForm?.querySelector('input[name="id"]');
    const selector = productForm?.querySelector('quantity-selector-component');
    const quantityInput = selector?.querySelector('input[name="quantity"]');
    const minusButton = selector?.querySelector('[name="minus"]');
    const plusButton = selector?.querySelector('[name="plus"]');
    if (!variantInput || !selector || !quantityInput || !minusButton || !plusButton) return;

    const variant = inventoryByVariant.get(String(variantInput.value));
    const isSingleItem = variant
      && variant.inventory_management
      && variant.inventory_policy === 'deny'
      && Number(variant.inventory_quantity) <= 1;

    if (isSingleItem) {
      quantityInput.value = '1';
      quantityInput.max = '1';
      minusButton.disabled = true;
      plusButton.disabled = true;
      minusButton.dataset.reluneInventoryLock = 'true';
      plusButton.dataset.reluneInventoryLock = 'true';
      selector.classList.add('relune-single-item');
      return;
    }

    selector.classList.remove('relune-single-item');
    quantityInput.removeAttribute('max');
    [minusButton, plusButton].forEach((button) => {
      if (button.dataset.reluneInventoryLock === 'true') {
        button.disabled = false;
        delete button.dataset.reluneInventoryLock;
      }
    });
    minusButton.disabled = Number(quantityInput.value) <= Number(quantityInput.min || 1);
  };

  document.addEventListener('change', () => requestAnimationFrame(updateQuantityControl));
  document.addEventListener('shopify:section:load', updateQuantityControl);
  updateQuantityControl();
});
